import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'app-progress-loading',
  templateUrl: './progress-loading.component.html',
  styleUrls: ['./progress-loading.component.scss'],
})
export class ProgressLoadingComponent {


  @Input() public text: string = "Loading...";
  @Input() public progress: number = 0;

  constructor(private toolsService: ToolsService) {
    console.debug("ProgressLoadingComponent constructor", this.text, this.progress);


    this.toolsService.progressLoadingChangeText.subscribe((text) => {
      this.setText(text);
    });

    this.toolsService.progressLoadingChangeProgress.subscribe((progress) => {
      this.setProgress(progress);
    });

  }

  public setText(text: string) {
    console.log("Set text", text);
    this.text = text;
  }

  public setProgress(progress: number) {
    console.log("Set progress", progress);
    this.progress = progress;
  }

}
